import { base_url } from './urls';
import axios from 'axios';
import Cookies from 'js-cookie';
// import { useAuth } from '../context/AuthProvider';

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================

const myApi = axios.create({

    baseURL: base_url

});

// Axios para login por key con token desde sessionStorage
const authApi = axios.create({
    
    baseURL: 'https://apiunidqr.ebtapps.com/api', // o la API solo para login

});

const otherApi = axios.create({
  baseURL: 'https://apicoresys.ebtapps.com/api'  // << API sin autenticación
});

// const { logOut } = useAuth();

// ===============================================
// AXIOS PARA LOS ENDPOINTS
// ===============================================
otherApi.interceptors.request.use(config => {
  config.headers['access-token'] = 'R9345FG35D68BE6R56ER51BSD36R51E6TJ8J';
  return config;
});

myApi.interceptors.request.use((config) => {

    //const token = Cookies.get('ebt_token');
    const token = 'R9345FG35D68BE6R56ER51BSD36R51E6TJ8J';
    //const token = sessionStorage.getItem('ebt_token'); 

    if(token){

        config.headers['access-token'] = token;

    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

authApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('ebt_token');

  if (token) {
    config.headers['access-token'] = token;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

myApi.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if(error.response.status === 500){

        //logOut();
        console.log(error)

    }

    return Promise.reject(error);

});

// ===============================================
// AXIOS PARA MANDAR FOTOS Y ARCHIVOS
// ===============================================

const myApiFiles = async (url, data, method = "POST") => {

    try {

        const config = {

            headers: {
                'Content-Type': 'multipart/form-data'

            }
            
        }

        const response = await myApi[method.toLowerCase()](url, data, config);

        return response.data;

    } catch( error ){

        throw error;

    }

}

// ===============================================
// AXIOS PARA DESCARGAR ARCHIVOS
// ===============================================

const myApiDownload = axios.create({

    baseURL: base_url,
    responseType: 'blob'

});

myApiDownload.interceptors.request.use((config) => {

    const token = Cookies.get('pk9_token');

    if(token){

        config.headers['Authorization'] = `Bearer ${token}`;

    }

    return config;

}, (error) => {

    return Promise.reject(error);

});

myApiDownload.interceptors.response.use((response) => {

    return response;

}, (error) => {

    if(error.response.status === 500){

        //logOut();

    }

    return Promise.reject(error);

});

export { myApi, myApiFiles, myApiDownload, authApi, otherApi };